import { EmeraldDialogTypes } from '../../common/enumerations/emerald-dialog-types';
import { IMessageModal } from 'src/common/interfaces/dtos/IMessageModal';
import { popupMessage } from '../../messages/business-logic/popup-message';
import { InterpolationArguments } from 'react-i18next';
import { AbortedError } from 'src/common/api/extended-emerald-error';

export const showEftInfo = (
  message: string,
  subMessage: string,
  acceptButtonLabel: string,
  closeButtonLabel?: string,
  subMessageArgs?: InterpolationArguments,
): Promise<void> => {
  return new Promise<void>((resolve, reject) => {
    const messageModal: IMessageModal = {
      message,
      type: EmeraldDialogTypes.Info,
      subMessage,
      onAccept: resolve,
      onCancel: () => reject(new AbortedError()),
      acceptButtonLabel,
      closeButtonLabel,
      subMessageArgs,
      disableBackdropClick: true,
    };
    popupMessage(messageModal);
  });
};
